import React, { Component, useEffect, useRef, useState } from "react";
import MainView from "../../GreekStatistics/components/DataViews/MainView/MainView";
import MapDisplayer from "./components/MapDisplayer/MapDisplayer";
import DataDisplayer from "./components/DataDisplayer/DataDisplayer";
import  "./DataViewer.css"


function DataViewer(props) {
    let d = useRef(null);
    React.useEffect(() => {

    })
    const setd = (value) => {
        d.current = value
    }
    return <div style={{ marginTop: "3%" }} className={'display_data_wrapper'}>
        <div className={"display_data__map"}><MapDisplayer data={d} completed={props.completed} formdata={props.formdata} areas={props.areas} /></div>
        <div><DataDisplayer setd={setd} setCompleted={props.setCompleted} setformstatus={props.setformstatus} formdata={props.formdata} completed={props.completed} /></div>
    </div>
}
export default DataViewer;